import React from "react"
import {Accordion, AccordionDetails, AccordionSummary, Typography} from "@mui/material"
import {ExpandMore as ExpandMoreIcon, Info as InfoIcon} from "@mui/icons-material"

import {CustomerCustomFieldsRecordedActivityPayload} from "@indebted/api"

function CustomFieldsRecordedActivity(
	panelId: number,
	{
		Title,
		HappenedAt,
		Payload,
	}: {Title: string; HappenedAt: string; Payload: CustomerCustomFieldsRecordedActivityPayload},
	expanded: boolean,
	handleExpand: (panelID: number) => (event: any, isExpanded: boolean) => void,
	classes: {summary: string; activityContent: string; activityContentLabel: string; activityContentValue: string},
) {
	return (
		<Accordion expanded={expanded} onChange={handleExpand(panelId)}>
			<AccordionSummary expandIcon={<ExpandMoreIcon />}>
				<InfoIcon color="primary" />
				<Typography className={classes.summary}>
					{" "}
					<b>{Title}</b> - {HappenedAt}
				</Typography>
			</AccordionSummary>
			<AccordionDetails>
				{expanded && (
					<div className={classes.activityContent}>
						{Payload.Fields.map((field) => (
							<div key={field.Name}>
								<Typography className={classes.activityContentLabel}>{field.Name}:</Typography>
								<Typography className={classes.activityContentValue}>{field.Value}</Typography>
							</div>
						))}
					</div>
				)}
			</AccordionDetails>
		</Accordion>
	)
}

export {CustomFieldsRecordedActivity}
